// extracted by mini-css-extract-plugin
module.exports = {"row":"row--1xSA8","name":"name--Mfa3n","footerLink":"footerLink--PRlUs","col":"col--35UON"};